import React, { lazy, Suspense, useState } from 'react'
import { CircularProgress } from '@mui/material'
import { FormikProps } from 'formik'
import { IManualDeliveryDetails } from 'types/api/v1/deliveryDetails.type'

const Step1Delivery = lazy(
  () => import('./ManualDeliverySteps/Step1ManualDelivery')
)
const Step2Delivery = lazy(
  () => import('./ManualDeliverySteps/Step2ManualDelivery')
)

interface DeliveryProps {
  formik: FormikProps<IManualDeliveryDetails>
}
function ManualDeliveryScheduling({ formik }: DeliveryProps) {
  const [activeDeliveryStep, setActiveDeliveryStep] = useState(0)

  const handleNextStep = () => {
    setActiveDeliveryStep((prevNum) => (prevNum += 1))
  }

  return (
    <>
      {activeDeliveryStep === 0 && (
        <Suspense fallback={<CircularProgress />}>
          <Step1Delivery handleNextStep={handleNextStep} formik={formik} />
        </Suspense>
      )}
      {activeDeliveryStep === 1 && (
        <Suspense fallback={<CircularProgress />}>
          <Step2Delivery />
        </Suspense>
      )}
    </>
  )
}

export default ManualDeliveryScheduling
